import { ProviderKey, ProviderPriority } from "@silo/types";

export const getProviderOverride = (
  envOverride: string
): ProviderKey | null => {
  if (/alchemy/i.test(envOverride)) {
    return "alchemy";
  }

  if (/infura/i.test(envOverride)) {
    return "infura";
  }

  if (/drpc/i.test(envOverride)) {
    return "drpc";
  }

  return null;
};

export const getAdjustedPriority = (
  providerPriority: ProviderPriority,
  envOverride: string
): ProviderPriority => {
  const override = getProviderOverride(envOverride);

  if (override === null) {
    return providerPriority;
  }

  return [
    override,
    ...providerPriority.filter((provider) => provider !== override),
  ] as unknown as ProviderPriority;
};
